import React, { Component } from 'react'

class PromotionVariantCatPartnerComponent extends Component {
    render() {
        return (
            <div></div>
        )
    }
}

export default PromotionVariantCatPartnerComponent


// WEBPACK FOOTER //
// ./src/application/components/promotions/components/types/variants/catPartner.js